import { Id } from "@dgs/core";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { PreferenceDrawer } from "../preferences/PreferenceDrawer";
import { usePreferenceQuery } from "../shared/api/preferences";
import { PreferenceFormValues } from "../shared/types/preference";

interface Props {
	preferenceId: Id;
	onSubmit: (preference: PreferenceFormValues) => Promise<any>;
	handleClose: () => void;
}

export const EditPreferenceDrawer: FC<Props> = ({ preferenceId, onSubmit, handleClose }) => {
	const { t } = useTranslation();
	const { data: preference } = usePreferenceQuery(preferenceId);

	if (!preference) {
		return null;
	}

	return (
		<PreferenceDrawer
			heading={t("Edit preference")}
			open={!!preferenceId}
			onSubmit={onSubmit}
			handleClose={handleClose}
			initialValues={preference}
		/>
	);
};
